import PropTypes from "prop-types";
import { Card, Radio, Select } from "antd";

const { Option } = Select;

export default function PatientFiltersCard({
  patients = [],
  selectedPatientId = null,
  onPatientChange,
  selectedClinicId = "all",
  onClinicChange = null,
  clinicOptions = [],
  programType,
  onProgramTypeChange,
  evalFilter = "all",
  onEvalFilterChange = null,
  showClinicFilter = true,
  showEvaluationFilter = false,
  t = null,
}) {
  const handleProgramTypeChange = (nextProgramType) => {
    if (nextProgramType !== "PACE") return;
    onProgramTypeChange(nextProgramType);
  };

  return (
    <Card className="patient-filters-card" bodyStyle={{ padding: 16 }}>
      <div className="patient-filters-top">
        <div className="patient-filters-left">
          <div className="patient-filters-label">
            {t ? t("stats_filter_patient", "Filtre patient") : "Choisir un patient"}
          </div>

          <Select
            value={selectedPatientId}
            onChange={onPatientChange}
            className="patient-filters-select"
            placeholder={t ? t("stats_select_patient_placeholder") : "Sélectionner un patient"}
            showSearch
            optionFilterProp="children"
          >
            {/* "Tous" bascule vers la page de statistiques globales. */}
            <Option key="all" value="all">
              {t ? t("stats_all_option", "Tous") : "Tous"}
            </Option>
            {patients.map((p) => (
              <Option key={p.id} value={p.id}>
                {`${p.firstname ?? ""} ${p.lastname ?? ""}`.trim() || `Patient #${p.id}`}
              </Option>
            ))}
          </Select>
        </div>

        <div className="patient-filters-right">
          <Radio.Group
            value={programType}
            onChange={(e) => handleProgramTypeChange(e.target.value)}
            buttonStyle="solid"
            className="patient-filters-radio"
          >
            <Radio.Button value="PACE">PACE</Radio.Button>
            <Radio.Button value="MATCH">MATCH</Radio.Button>
            <Radio.Button value="PATH">PATH</Radio.Button>
          </Radio.Group>
        </div>
      </div>

      {(showClinicFilter || showEvaluationFilter) && (
        <div className="patient-filters-bottom">
          {showClinicFilter && (
            <div className="patient-filters-sub-item">
              <div className="patient-filters-label">
                {t ? t("stats_filter_clinic", "Filtre clinique") : "Filtre clinique"}
              </div>
              <Select
                value={selectedClinicId}
                onChange={onClinicChange}
                className="patient-filters-select"
                placeholder={
                  t
                    ? t("stats_all_clinics_placeholder", "Toutes les cliniques")
                    : "Toutes les cliniques"
                }
              >
                <Option value="all">{t ? t("stats_all_option", "Tous") : "Tous"}</Option>
                {clinicOptions.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </div>
          )}

          {showEvaluationFilter && (
            <div className="patient-filters-sub-item">
              <div className="patient-filters-label">
                {t ? t("stats_filter_evaluation", "Filtre évaluation") : "Filtre évaluation"}
              </div>
              <Select
                value={evalFilter}
                onChange={onEvalFilterChange}
                className="patient-filters-select"
              >
                {/* "Tous" = tous les patients (T0/T1 et T1 non effectué). */}
                <Option value="all">{t ? t("stats_all_option", "Tous") : "Tous"}</Option>
                <Option value="t1_done">
                  {t ? t("stats_eval_t1_done", "Éval T1 effectuée") : "Éval T1 effectuée"}
                </Option>
              </Select>
            </div>
          )}
        </div>
      )}
    </Card>
  );
}

PatientFiltersCard.propTypes = {
  patients: PropTypes.array,
  selectedPatientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onPatientChange: PropTypes.func.isRequired,
  selectedClinicId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClinicChange: PropTypes.func,
  clinicOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  programType: PropTypes.oneOf(["PACE", "MATCH", "PATH"]).isRequired,
  onProgramTypeChange: PropTypes.func.isRequired,
  evalFilter: PropTypes.oneOf(["all", "t1_done"]),
  onEvalFilterChange: PropTypes.func,
  showClinicFilter: PropTypes.bool,
  showEvaluationFilter: PropTypes.bool,
  t: PropTypes.func,
};
